import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M12,9.63a.88.88,0,0,0-.88.87V13a.88.88,0,0,0,1.76,0V10.5A.88.88,0,0,0,12,9.63Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M22.5,4.5H1.5A1.5,1.5,0,0,0,0,6V18a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,18V6A1.5,1.5,0,0,0,22.5,4.5ZM6.43,10.87l1.84,1.22A1.94,1.94,0,0,1,7.2,15.63H5.5a.63.63,0,0,1,0-1.25H7.2a.68.68,0,0,0,.37-1.25L5.73,11.91a1.94,1.94,0,0,1-.85-1.61A1.92,1.92,0,0,1,6.8,8.38H8.5a.63.63,0,0,1,0,1.25H6.8a.68.68,0,0,0-.68.67A.69.69,0,0,0,6.43,10.87ZM14.12,13a2.09,2.09,0,0,1-1,1.77.1.1,0,0,0,0,.16l.73.58a.64.64,0,0,1,.1.88.63.63,0,0,1-.88.1L11.18,15a2.13,2.13,0,0,1-1.3-2V10.5a2.12,2.12,0,0,1,4.24,0Zm4.38,2.63h-2A1.62,1.62,0,0,1,14.88,14V9a.62.62,0,1,1,1.24,0v5a.38.38,0,0,0,.38.38h2a.63.63,0,0,1,0,1.25Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }